import React, { Component } from 'react'
import { Route, Redirect, withRouter } from 'react-router-dom'

class PortalRoute extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.scrollToTop && this.props.location !== prevProps.location) {
      window.scrollTo(0, 0)
    }
  }

  render() {
    const { component: Component, authenticated: user, appName, ...rest } = this.props

    return <Route {...rest} render={props =>
      {
        return user.isLoggedIn && user.reduxLogInComplete
        ? (
          <Component {...props} appName={appName} path={props.location.pathname}/>
        )
        : (
          <Redirect to={{
            pathname: '/log-in'
          }}/>
        )
      }
    }/>
  }
}

export default withRouter(PortalRoute)


// WEBPACK FOOTER //
// ./src/components/Routes/PortalRoute.js